import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";
import { dashboardsUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import {
  Dashboard,
  DashboardPresentation,
  DashboardStatus,
} from "@src/types/dashboards";

/** Partial PATCH body. Each field is independently optional; the BE
 *  merges whatever it receives. To clear a user's theme on a single
 *  dashboard, send `presentation: { colors: null }`. To remove the
 *  presentation field entirely, send `presentation: null`. Both forms
 *  are treated identically by the FE on read. */
export interface PatchDashboardPayload {
  name?: string;
  description?: string | null;
  status?: DashboardStatus;
  is_default?: boolean;
  presentation?: DashboardPresentation | null;
}

export const patchDashboardV2 = async (
  namespace: string,
  dashboardId: string,
  payload: PatchDashboardPayload,
): Promise<{ data: Dashboard }> => {
  const url = dashboardsUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();

  try {
    const response = await axios.patch<Dashboard>(
      `${url}/api/v2/ns/${namespace}/dashboards/${dashboardId}`,
      payload,
      { headers },
    );
    return response;
  } catch (err) {
    if (isAxiosError(err)) {
      console.error("Axios error:", err);
      throw new Error(
        err.response?.data?.detail ||
          err.response?.data?.message ||
          "Failed to update dashboard. Please try again later.",
      );
    }
    throw new Error("An unexpected error occurred while updating dashboard.");
  }
};
